import { componentName, SecurityQuestionsSetupClass } from './SecurityQuestionsSetupClass';
import '../descope-text-field';
import '@descope-ui/descope-combo-box';

customElements.define(componentName, SecurityQuestionsSetupClass);

export { SecurityQuestionsSetupClass, componentName };
